import ModulePage from "../ModulePage/ModulePage";

const ProfessionalsSanitaris = () => <ModulePage />;

export default ProfessionalsSanitaris;
